import { render, staticRenderFns } from "./login_bind_account.vue?vue&type=template&id=106b04e4&scoped=true"
import script from "./login_bind_account.vue?vue&type=script&lang=js"
export * from "./login_bind_account.vue?vue&type=script&lang=js"
import style0 from "./login_bind_account.vue?vue&type=style&index=0&id=106b04e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b04e4",
  null
  
)

export default component.exports